import api from "../services/api";

export const getReviews = (vendorId, queryParams) => {
  const { withText = "", page = "", groups = "", productSourceIds = "", scoreGte = "",
          scoreLte = "", reviewStatus, pageSize, createdAfterDate, createdBeforeDate, companyId, group } = queryParams;

  const url = `reviews/vendors/${vendorId}/reviews?status=${reviewStatus}&scoreGte=${scoreGte}&scoreLte=${scoreLte}&pageSize=${pageSize}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}&groups=${group}&productSourceIds=${productSourceIds}&withText=${withText}&page=${page}&companyId=${companyId}`;

  return new Promise((resolve, reject) => {
    api
      .get(url)
      .then(response => resolve(response.data))
      .catch(error => reject(`Error: ${error}`));
  });
};



export const getReviewsCSV = (
  vendorId,
  group,
  product,
  createdAfterDate,
  createdBeforeDate
) => {
  return new Promise((resolve, reject) => {
    api
      .get(
        `feedback/csvforfeedback?vendorId=${vendorId}&group=${group}&product=${product}&createdAfter=${createdAfterDate}&createdBefore=${createdBeforeDate}`
      )
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => reject(`Error: ${error}`));
  });
};
